var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "text-red text-size-18 font-bold" }, [
      _c("i", {
        staticClass: "fa fa-exclamation-triangle",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.total +
              "点中" +
              _vm.failedCount +
              "点の商品が追加されませんでした"
          ) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "text--underline",
        on: { click: _vm.downloadErrorReport }
      },
      [_vm._v("レポートをダウンロード")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-217f692f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-217f692f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/sale/components/SaleEntryError.vue
// module id = null
// module chunks = 